/**
 * Innovation Section Animation - Homepage
 * Vanilla JavaScript replacement for jQuery-based scroll animations
 */

class InnovationAnimation {
  constructor() {
    this.desktopGroups = [
      ['.innovation-item-1', '.innovation-item-4'],
      ['.innovation-item-2', '.innovation-item-5'],
      ['.innovation-item-3', '.innovation-item-6']
    ];
    this.mobileGroups = [
      ['.innovation-item-1'],
      ['.innovation-item-2'],
      ['.innovation-item-3'],
      ['.innovation-item-4'],
      ['.innovation-item-5'],
      ['.innovation-item-6']
    ];
    this.currentGroup = 0;
    this.isAnimating = false;
    
    // Wait for DOM to be ready
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => this.init());
    } else {
      this.init();
    }
  }

  init() {
    // Check if innovation section exists
    const innovationSection = document.querySelector('.innovation-section');
    if (!innovationSection) {
      return;
    }

    // Ensure initial states are set
    this.setInitialStates();

    // Responsive column ordering
    this.handleColumnOrder();
    window.addEventListener('resize', () => this.handleColumnOrder());

    // Setup scroll handler with throttling
    let ticking = false;
    window.addEventListener('scroll', () => {
      if (!ticking) {
        window.requestAnimationFrame(() => {
          this.handleScroll();
          ticking = false;
        });
        ticking = true;
      }
    }, { passive: true });

    // Trigger on initial load if section is already visible
    setTimeout(() => {
      this.handleScroll();
    }, 100);
  }

  setInitialStates() {
    // Ensure all innovation items start hidden
    const allItems = document.querySelectorAll('.innovation-item-1, .innovation-item-2, .innovation-item-3, .innovation-item-4, .innovation-item-5, .innovation-item-6');
    allItems.forEach(item => {
      if (!item.style.opacity) {
        item.style.opacity = '0';
        if (item.classList.contains('innovation-item-1') || 
            item.classList.contains('innovation-item-2') || 
            item.classList.contains('innovation-item-3')) {
          item.style.transform = 'translateX(-40px)';
        } else {
          item.style.transform = 'translateX(40px)';
        }
      }
    });
  }

  handleColumnOrder() {
    const col1 = document.querySelector('.innovation-col-1');
    const col2 = document.querySelector('.innovation-col-2');
    
    if (!col1 || !col2) return;

    const isMobile = window.matchMedia('(max-width: 768px)').matches;
    
    if (isMobile) {
      // Move col-2 before col-1 on mobile
      if (col2.nextElementSibling !== col1) {
        col1.parentNode.insertBefore(col2, col1);
      }
    } else {
      // Move col-1 before col-2 on desktop
      if (col1.nextElementSibling !== col2) {
        col2.parentNode.insertBefore(col1, col2);
      }
    }
  }

  handleScroll() {
    const isMobile = window.matchMedia('(max-width: 768px)').matches;
    const groups = isMobile ? this.mobileGroups : this.desktopGroups;

    if (this.currentGroup >= groups.length || this.isAnimating) return;

    const scrollPosition = window.scrollY + window.innerHeight;
    const firstElement = document.querySelector(groups[this.currentGroup][0]);

    if (firstElement) {
      const elementTop = firstElement.getBoundingClientRect().top + window.scrollY;
      const triggerPoint = elementTop - (window.innerHeight * 0.2); // Trigger when 20% from top

      if (scrollPosition > triggerPoint) {
        this.isAnimating = true;

        // Animate all elements in current group
        groups[this.currentGroup].forEach(selector => {
          const elements = document.querySelectorAll(selector);
          elements.forEach(element => {
            element.style.opacity = '1';
            element.style.transform = 'translateX(0)';
          });
        });

        setTimeout(() => {
          this.isAnimating = false;
          this.currentGroup++;
        }, 300);
      }
    }
  }
}

// Initialize - scripts are conditionally loaded by Liquid template
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    new InnovationAnimation();
  });
} else {
  new InnovationAnimation();
}

